module.exports = __webpack_public_path__ + "img/m7.ad8d2550.jpg";